import {store} from "../store";
import moment from 'moment';

export default{
    getUser(){
        return store.state.user.name;
    },
    getUserName(){
        return store.state.user.name;
    },
    getUserEmail(){
        return store.state.user.email;
    },    
    spliceArray(array, id){
        for(var i = 0; i < array.length; i += 1) {
            if(array[i].id === id) {
                array.splice(i,1);
            }
        }
    },
    findFromArray(array, id){
        return array.find(item => { return item.id == id  });
    },    
    createFileInfoObjFromUploadWindowObj(objIn){
        return {
            id                  : this.getUniqueID(), 
            parentID            : objIn.parentInfo.parentID, 
            createdAt           : objIn.createdAt, 
            modifiedAt          : objIn.createdAt, 
            createdBy           : objIn.createdBy, 
            modifiedBy          : objIn.createdBy,
            file                : objIn.file,
            fileName            : objIn.fileName,
            fileURL             : '',
            fileDir             : objIn.parentInfo.type,
            status              : objIn.status,
            fileSize            : objIn.fileSize,
            fileType            : objIn.fileType,
            fileNameWithPrefix  : objIn.fileNameWithPrefix,
            parentInfo          : objIn.parentInfo,
        };            
    },
    convertFileInfoObjToUploadWindowObj(objIn){
        return {
            id                  : objIn.id,
            file                : objIn.file,
            fileName            : objIn.fileName,
            fileURL             : objIn.fileURL,
            fileDir             : objIn.fileDir,
            status              : objIn.status,
            fileSize            : objIn.fileSize,
            fileType            : objIn.fileType,
            fileNameWithPrefix  : objIn.fileNameWithPrefix,
            createdAt           : objIn.createdAt,
            createdBy           : objIn.createdBy,
            parentInfo          : objIn.parentInfo,
        }
    },

    // DATE TIME
    dateformatter(value) {

        if(value.length < 8){
            return value;
        }else if(value.substring(2,3) == '/' && value.substring(5,6) == '/'){ // Already formatted
            return value;
        }else if (value.length == 8){
            const formattedDate  = value.substring(0,2) + '/' + value.substring(2,4) + '/' + value.substring(4);
            if(this.isValidDate(formattedDate)){
                return formattedDate;
            }else{
                return value;
            }                           
        }            

        return value;
    },
    isValidDateForInput(dateIn){
        if(dateIn == '')
            return null
        else 
            return this.isValidDate(dateIn);
    },
    isValidDate(dateIn){
        if(dateIn != '' && moment(dateIn, 'DD/MM/YYYY',true).isValid() == false){
            return false;
        }
        return true;
    },
    
    
    getUTCTime(){ 
        var d = new Date();
        var mon = (d.getUTCMonth() + 1).toString();
        var day = d.getUTCDate().toString();
        var hrs = d.getUTCHours().toString();
        var mins = d.getUTCMinutes().toString();
        var secs = d.getSeconds().toString();
        var mills = d.getUTCMilliseconds().toString();
        if(mon.length == 1)
          mon = "0" + mon;
        if(day.length == 1)
          day = "0" + day;
        if(hrs.length == 1)
          hrs = "0" + hrs;
        if(mins.length == 1)
          mins = "0" + mins;
        if(secs.length == 1)
          secs = "0" + secs;
        if(mills.length == 1){
          mills = "00" + mills;
        }else if(mills.length == 2){
          mills = "0" + mills;
        }

        return d.getUTCFullYear() + "-" + mon + "-" + day + " " + hrs + ":" + mins + ":" + secs + ":" + mills;
      },
      getUTCTimeFormatted(){ 
        var d = new Date();
        var mon = (d.getUTCMonth() + 1).toString();
        var day = d.getUTCDate().toString();
        var hrs = d.getUTCHours().toString();
        var mins = d.getUTCMinutes().toString();
        var secs = d.getSeconds().toString();
        if(mon.length == 1)
          mon = "0" + mon;
        if(day.length == 1)
          day = "0" + day;
        if(hrs.length == 1)
          hrs = "0" + hrs;
        if(mins.length == 1)
          mins = "0" + mins;
        if(secs.length == 1)
          secs = "0" + secs;
        

        return d.getUTCFullYear() + "-" + mon + "-" + day + " " + hrs + ":" + mins + ":" + secs;
      },
      formatDateTime(input){
            const timeStampDate = input;
            const dateInMillis  = timeStampDate.seconds * 1000;
            const date = new Date(dateInMillis);

            const months = ["JAN", "FEB", "MAR","APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
            const formatted_date = date.getFullYear() + "-" + months[date.getMonth()] + "-" + date.getDate()

            return formatted_date + ' ' + new Date(dateInMillis).toLocaleTimeString();
        },
      getDate(){
        var d = new Date();
        var mon = (d.getMonth() + 1).toString();
        var day = d.getDate().toString();
        if(mon.length == 1)
          mon = "0" + mon;
        if(day.length == 1)
          day = "0" + day;

        return day + "/" + mon + "/" + d.getFullYear();
      },
      getDateMonthInLetters(){
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        var d = new Date();
        var mon = monthNames[d.getMonth()]
        var day = d.getDate().toString();
        if(day.length == 1)
          day = "0" + day;

        return d.getFullYear() + "-" + mon + "-" + day;
      },
      getUTCDateTime(){ 
        var d = new Date();
        var mon = (d.getUTCMonth() + 1).toString();
        var day = d.getUTCDate().toString();
        var hrs = d.getUTCHours().toString();
        var mins = d.getUTCMinutes().toString();
        var secs = d.getSeconds().toString();
        if(mon.length == 1)
          mon = "0" + mon;
        if(day.length == 1)
          day = "0" + day;
        if(hrs.length == 1)
          hrs = "0" + hrs;
        if(mins.length == 1)
          mins = "0" + mins;
        if(secs.length == 1)
          secs = "0" + secs;


        return d.getUTCFullYear() + "/" + mon + "/" + day + "-" + hrs + ":" + mins + ":" + secs;
      },
      getDateTime(){ 
        var d = new Date();
        var mon = (d.getMonth() + 1).toString();
        var day = d.getDate().toString();
        var hrs = d.getHours().toString();
        var mins = d.getMinutes().toString();
        var secs = d.getSeconds().toString();
        if(mon.length == 1)
          mon = "0" + mon;
        if(day.length == 1)
          day = "0" + day;
        if(hrs.length == 1)
          hrs = "0" + hrs;
        if(mins.length == 1)
          mins = "0" + mins;
        if(secs.length == 1)
          secs = "0" + secs;


        return d.getFullYear() + "/" + mon + "/" + day + "-" + hrs + ":" + mins + ":" + secs;
      },
      getUniqueID(){
          return new Date().getMilliseconds() + "_" + Math.random();
      },
      getUniqueIDWithSeed(seed){
        return seed+ new Date().getMilliseconds();
      }
}
